import { Component, OnInit, Input } from "@angular/core";

import {
  Dialog,
  SharedModule,
  DataService,
  NotificationService,
  LanguageCode,
} from "@bb-vendure/admin-ui/core";
import { FormBuilder, Validators } from "@angular/forms";

@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./export-invoice-dialog.component.html",
})
export default class ExportInvoiceDialog
  implements Dialog<any>, OnInit
{
  selectedLanguage: LanguageCode = LanguageCode.en;

  @Input()
  total: number;

  ngOnInit(): void {}

  availableLanguages = [LanguageCode.en, LanguageCode.ko, LanguageCode.zh];

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService
  ) {}
  resolveWith: (result?: LanguageCode) => void;

  cancel() {
    this.resolveWith();
  }

  setLanguage(newLang: LanguageCode) {
    this.selectedLanguage = newLang;
  }

  save() {
    this.resolveWith(this.selectedLanguage);
  }
}
